import { BigNumber } from '@xylabs/bignumber'

export const parseBigNumber = (input: { toString: () => string }) => new BigNumber(input.toString())

export const parseBigNumberOptional = (input?: { toString: () => string }, defaultValue?: BigNumber | string | number) => {
  if (input) {
    return new BigNumber(input.toString())
  }
  if (defaultValue) {
    return new BigNumber(defaultValue)
  }
}
